import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { useSpotsLeft } from "../hooks/useSpotsLeft";
export function ScarcityBar() {
  const {
    spots,
    total
  } = useSpotsLeft();
  const filled = (total - spots) / total * 100;
  return <div className="mx-auto mt-6 w-full max-w-xl rounded-2xl bg-white/10 p-4 ring-1 ring-white/15" data-id="element-55" data-mp="2q40x4cecmaso">
      <div className="flex items-center justify-between gap-3 text-sm" data-id="element-56" data-mp="2b6qf0k77a6nz">
        <p className="flex items-center gap-2 font-bold text-white" data-id="element-57" data-mp="2b8us9sqzoi0x">
          <FlameIcon className="h-4 w-4 shrink-0 text-peach" aria-hidden="true" data-id="element-58" data-mp="2g6mjekjt8042" />
          Only <span className="text-peach" data-id="element-59" data-mp="2273ncq49wf84">{spots} spots</span> left at $27
        </p>
        <span className="shrink-0 font-semibold tabular-nums text-white/75" data-id="element-60" data-mp="274mz9jdi0fww">{Math.round(filled)}% claimed</span>
      </div>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-61" data-mp="fql68towlfr">
        <motion.div className="h-full rounded-full bg-peach" initial={{
        width: "80%"
      }} animate={{
        width: `${filled}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-62" data-mp="2zlji4gjmotyl" />
      </div>
      <p className="mt-2 text-xs text-white/65" data-id="element-63" data-mp="38ewiu4nxozv8">When these spots are gone, the promotional price ends.</p>
    </div>;
}